import React, { FC, useState } from "react";
import { UIBrandedFareInfo, UIFlightSegment } from "@flights/types";
import Frame from "components/elements/Frame";
import { useFlightCardLuggageWithCheckmarksController } from "./useFlightCardLuggageWithCheckmarksController";
import { Stack, Text, TextProps } from "@bookingcom/bui-react";
import { lowerCase, startCase } from "lodash";
import flights_web_flexible_ticket_icon from "utils/experiments/funnel/flights_web_flexible_ticket_icon";
import { CardAncillariesPopover } from "@flights/search-ui";
import { AlignerProps } from "@bookingcom/bui-react/components/Button/Button.types";
import { useShouldTrackSplitBounds } from "utils/experiments/funnel/flights_split_bounds_us";

export const FlightCardLuggageWithCheckmarks: FC<{
  segments: UIFlightSegment[];
  showFareName: boolean;
  brandedFareInfo?: UIBrandedFareInfo;
  showFlexIcon?: boolean;
  buttonAlignment?: AlignerProps["alignment"];
  brandedFareInfoAlignment?: TextProps["align"];
}> = ({
  segments,
  showFareName,
  brandedFareInfo,
  showFlexIcon = false,
  buttonAlignment,
  brandedFareInfoAlignment = "end"
}) => {
  const { cabinBagText, personalBagText, checkedBagText, titleText, flexTicketText } =
    useFlightCardLuggageWithCheckmarksController(segments);
  const shouldTrackSplitBounds = useShouldTrackSplitBounds();

  /* start - flights_web_flexible_ticket_icon */
  const [popoverOpened, setPopoverOpened] = useState(false);
  const handlePopoverOpen = () => {
    if (!popoverOpened) {
      flights_web_flexible_ticket_icon.goals.popoverTriggered();
    }
    setPopoverOpened(true);
  };
  /* end - flights_web_flexible_ticket_icon */

  if (!cabinBagText && !personalBagText && !checkedBagText && !showFlexIcon) {
    return null;
  }

  return (
    <Stack gap={0.5}>
      {showFareName && brandedFareInfo && (
        <BrandedFareDescription fareName={brandedFareInfo?.fareName} align={brandedFareInfoAlignment} />
      )}
      <CardAncillariesPopover
        align="end"
        personalBagText={personalBagText}
        cabinBagText={cabinBagText}
        checkedBagText={checkedBagText}
        /* start - flights_web_flexible_ticket_icon */
        onPopoverOpen={handlePopoverOpen}
        titleText={
          !shouldTrackSplitBounds && !flights_web_flexible_ticket_icon.trackWithDefaultStage() ? titleText : undefined
        }
        flexTicketText={showFlexIcon ? flexTicketText : undefined}
        /* end - flights_web_flexible_ticket_icon */
        buttonAlignment={buttonAlignment}
      />
    </Stack>
  );
};

export const BrandedFareDescription = ({
  fareName,
  align
}: {
  fareName: UIBrandedFareInfo["fareName"] | undefined;
  align: TextProps["align"];
}) => {
  if (!fareName) {
    return null;
  }

  return (
    <Frame>
      <Text variant="small_1" align={align} color="neutral">
        {startCase(lowerCase(fareName))}
      </Text>
    </Frame>
  );
};

export default FlightCardLuggageWithCheckmarks;
